import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const BuyCreditsLinksLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "BuyCreditsLinks" */
      './BuyCreditsLinks.dynamic'
    ),
  loading: LoadingPageLoadable,
});
